(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').directive('mxEnsureUnique', [
		'mx.SolutionBuilderAgent.EntityService',
		'mx.internationalization',
		'$q',
		'$timeout',
		function mxEnsureUniqueDirective(mxEntityService, i18n, $q, $timeout) {
			var message = i18n.get('solutionBuilderAgent.form-validation.unique');

			return {
				require: ['ngModel', '?^mxForm', '?^^mxServiceContext'],
				link: function (scope, element, attrs, ctrl) {
					if (typeof attrs.mxEnsureUnique === 'string') {
						var parts = [];
						var statementStartIndex = attrs.mxEnsureUnique.indexOf('[');
						if (statementStartIndex !== -1) {
							parts.push(attrs.mxEnsureUnique.substr(0, statementStartIndex));
							parts.push(attrs.mxEnsureUnique.substr(statementStartIndex));
						} else {
							parts = attrs.mxEnsureUnique.split('.');
						}

						if (parts.length === 2) {
							var ngModelCtrl = ctrl[0];

							ngModelCtrl.mxErrorMessages.unique = message;
							var formObjectId = null;
							var mxForm = ctrl[1];

							if (mxForm) {
								formObjectId = mxForm.objectId;
								if (formObjectId === 'new') {
									formObjectId = null;
								}
							}

							const mxServiceContext = ctrl[2];

							if (!formObjectId) {
								// use fragmentID for wizards based on DD
								formObjectId =
									mxServiceContext?.mxServiceContext?.Context?.Object?.Id ||
									mxServiceContext?.mxServiceContext?.Context?.Object?.ID ||
									'00000000-0000-0000-0000-000000000000';
							}

							var pendingValidation;
							var resultCache = {};

							ngModelCtrl.$asyncValidators.unique = function (modelValue, viewValue) {
								if (pendingValidation) {
									$timeout.cancel(pendingValidation);
								}
								if (!viewValue) {
									return $q.when();
								}

								pendingValidation = $timeout(function () {
									pendingValidation = null;

									// returns promise or value
									var deferred = $q.defer();
									if (viewValue) {
										var res = resultCache[viewValue.toLowerCase()];
										if (res !== undefined) {
											if (res) {
												deferred.resolve();
											} else {
												deferred.reject();
											}
										} else {
											mxEntityService.ensureUniqueValue(parts[0], parts[1], formObjectId, viewValue, mxForm.entityName).then(function (isUnique) {
												resultCache[viewValue.toLowerCase()] = isUnique;
												if (isUnique) {
													deferred.resolve();
												} else {
													deferred.reject();
												}
											});
										}
									} else {
										deferred.resolve();
									}

									return deferred.promise;
								}, 1000);

								return pendingValidation;
							};
						}
					}
				},
			};
		},
	]);
})();
